import React from 'react'
import {
    BrowserRouter as Router,
    Redirect,
    withRouter,
    Route
  } from "react-router-dom";
import Header from "./Header"
import Footer from "./Footer"
import Home from "../pages/Home/index"
import AccountActivated from "../pages/Home/account-activated"
import SmsVerified from "../pages/Home/sms-verified"
import { hasAnyRoleExist, setPanelHeight } from "../actions/utils";

class LoginLayout extends React.Component {
    constructor(props)
    {
        super(props);
    }

    componentDidMount() {
        setPanelHeight();
        window.addEventListener('load', setPanelHeight);
        window.addEventListener('resize', setPanelHeight);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', setPanelHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        setPanelHeight();
    }

    render() {
        if(this.props.location.pathname.indexOf('/sms-verified/') < 0)
        {
            if(localStorage.getItem('user') != null && hasAnyRoleExist("Sales"))
            {
                return (<Redirect
                            to={{
                                pathname: "/agent",
                                state: { from: this.props.location }
                            }}
                        />
                  );
            }
            else if(localStorage.getItem('user') != null && hasAnyRoleExist("Standart"))
            {
                return (<Redirect
                            to={{
                                pathname: "/user",
                                state: { from: this.props.location }
                            }}
                        />
                  );
            }
            else if(localStorage.getItem('user') != null && (hasAnyRoleExist(["XIVodafone","XIPartner"])))
            {
                return (<Redirect
                            to={{
                                pathname: "/xivodafone/client/list",
                                state: { from: this.props.location }
                            }}
                        />
                  );
            }
            else if (localStorage.getItem('user') != null && (hasAnyRoleExist(["XIVFAdmin"]))) {
                return (<Redirect
                    to={{
                        pathname: "/xivodafone/approve/list",
                        state: { from: this.props.location }
                    }}
                />
                );
            }
            else if(localStorage.getItem('user') != null && hasAnyRoleExist("XIConsultant"))
            {
                return (<Redirect
                            to={{
                                pathname: "/xivodafone/query/list",
                                state: { from: this.props.location }
                            }}
                        />
                  );
            }            
        }

        return (
            <div>
                <Header />
                <Route exact path="/account-activated/:id" component={AccountActivated} />
                <Route exact path="/sms-verified/:id" component={SmsVerified} />
                <Route exact path="/" component={Home} />
                <Footer />
            </div>
        );
    }
}

export default LoginLayout;